import { BUTTON_REF_CLASS, CURRENT_GROUP_CLASSES } from '../components/product-group-navigator'
import scrollTo from 'animated-scroll-to'
import { BehaviorSubject } from 'rxjs'
import { isBrowser } from '@/utils/env'

export function createProductGroupIntersectionObserver() {
  if (!isBrowser) {
    return undefined
  }
  const intersectionState = new BehaviorSubject<{
    [productGroupName: string]: IntersectionObserverEntry
  }>({})

  return new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        const productGroupName =
          entry.target.attributes.getNamedItem('data-product-group-name')!.value
        intersectionState.next({
          ...intersectionState.value,
          [productGroupName]: entry,
        })
      }
      const intersectingEntries = Object.entries(intersectionState.value)
        .filter(([, v]) => {
          return v.isIntersecting
        })
        .sort((a, b) => {
          return b[1].time - a[1].time
        })

      if (intersectingEntries.length > 0) {
        const entry = intersectingEntries[0]!
        const navigatorButton = document.getElementById(`pg-b-${entry[0]}`)!
        if (!navigatorButton) {
          return
        }
        for (const button of document.getElementsByClassName(BUTTON_REF_CLASS)) {
          button.classList.remove(...CURRENT_GROUP_CLASSES.split(' '))
        }
        navigatorButton.classList.add(...CURRENT_GROUP_CLASSES.split(' '))
        scrollTo(navigatorButton, {
          maxDuration: 300,
          elementToScroll: document.getElementById('product-group-navigator')!,
        })
      }
    },
    { rootMargin: `-100px 0px ${-window.innerHeight + 164}px` },
  )
}
